import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { ApiConstants } from '../constants/ApiConstants';
import useMakeRequest from '../utils/ApiHelper';
import FrontLoader from '../component/layout/FrontLoader';
import { useNavigate } from 'react-router-dom';
import { Config } from '../config/Config';
import { LanguageConstants } from '../constants/LanguageConstants';
import { getPriceHelper } from '../utils/Helper';
import { socket } from '../utils/Socket';

function CheckOutModal(props:any) {
  const userData = useSelector((state:any)=>state?.ProfileState)
  const [payMethod , setPayMethod] = useState('')
  const [error , setError] = useState('')
  const OrderAdd = useMakeRequest()
  const navigate  = useNavigate()
    
    const getTaxValue = (e: any) => {
        if (e?.tax_amount && e?.total_amount) {
            const total = Number(e?.total_shipping_price) + Number(e?.total_product_price) + Number(e?.other_charges)
            const taxValue = (total * e?.tax_amount) / 100;
            return `${taxValue.toFixed(2)}`; 
        } else {
            return '0.00';
        }
    };

    const handleChangeAddress = ()=>{
        props?.setAddressMessageShow(true)
        props?.handleClose()
    }

    const handlePayment =()=>{
      if(!payMethod){
       return setError(`${LanguageConstants?.SELETE_PAYMENT_ERROR}`)
      }else{
        const payload ={
            quotation_id:props?.data?.quotation_id,
            address_id:props?.data?.address_id,
            total_amount:props?.data?.total_amount,
            payment_type:payMethod,
            success_url:Config.REACT_APP_SUCCESSFULLY,
            cancel_url:Config.REACT_APP_CANCEL,
            type:'web'
        }
        OrderAdd.makeRequest({payload, url: ApiConstants?.OrderAdd, toastStatus: false }) 
        setError('')
      }
    }


    useEffect(()=>{
    if(OrderAdd?.status){
        if(OrderAdd.data?.data?.url){
            // window.open(OrderAdd?.data?.data?.url);
            window.location.href= OrderAdd?.data?.data?.url
            props?.handleClose()
        }else{
             const socketpayload ={
                            sender_type: "1",
                            receiver_id: '1'
                  }
                  socket.emit('admin_count', socketpayload, async (Response: any) => {
                    })
            props?.handleClose()
            props?.setPaymentshow(true)
        }
    }
    },[OrderAdd?.status])


  return (
    <>
    {OrderAdd?.loading ? <FrontLoader/> : null }
     <div className="modal fade com-modal short-modal checkout-modal show" id="checkoutModal" aria-labelledby="checkoutModalLabel" aria-hidden="true" style={{display: "block"}} >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="checkoutModalLabel">{LanguageConstants?.CHECKOUT}</h5>
                            <button onClick={()=>props?.handleClose()} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"><i className="icon-close-square" /></button>
                        </div>
                        <div className="modal-body pb-0 text-start">
                            <div className="id-mob">
                                <div className=""><span className="id-mob-label">{LanguageConstants?.QUOTATIONID} :</span>  {props?.data?.quotation_id}</div>
                                {userData?.data?.data?.phone_number ? 
                                <div className=""><span className="id-mob-label">{LanguageConstants?.MOBILE} :</span>  {userData?.data?.data?.phone_country_code} {userData?.data?.data?.phone_number}</div>
                                :null}
                            </div>
                            <div className="checkout-address">
                                <div>
                                    <label className="check-add-label">{LanguageConstants?.ADDRESS}</label>
                                    <div className="check-add-ct">{`${props?.data?.address_detail?.street_line} , ${props?.data?.address_detail?.zip_code ? props?.data?.address_detail?.zip_code : null}`}</div>
                                </div>
                                {props?.data?.parent_id  == null ? 
                                <button onClick={()=>handleChangeAddress()} className="edit-address"><i className="icon-edit-profile"></i> <span>{LanguageConstants?.EDIT}</span></button>
                                 : null}
                                </div>
                            <div className="">
                                <div className="check-heading">{LanguageConstants?.PRICE_BRACKDOWN}</div>
                                <div className="table-responsive mb-4">
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <td>{LanguageConstants?.TOTALPRODUCTAMOUNT}</td>
                                                <td>${getPriceHelper(props?.data?.total_product_price)}</td>
                                            </tr>
                                            <tr>
                                                <td>{LanguageConstants?.TOTALSHIIPNGAMOUNT}</td>
                                                <td>${getPriceHelper(props?.data?.total_shipping_price)}</td>
                                            </tr>
                                            <tr>
                                                <td>{LanguageConstants?.OTHER_CARGERS}</td>
                                                <td>$ {props?.data?.other_charges ? getPriceHelper(props?.data?.other_charges) : '0.00'}</td>
                                            </tr>
                                            <tr>
                                                <td>{LanguageConstants?.TOTALTAX}</td>
                                                <td>${getPriceHelper(getTaxValue(props?.data))}</td>
                                            </tr>
                                            <tr>
                                                <td>{LanguageConstants?.NET_ORDER_AMOUNT}</td>
                                                <td>${getPriceHelper(props?.data?.total_amount)}</td>
                                            </tr>
                                        </tbody>
                                <p style={{color:'red'}}>{LanguageConstants?.PRIZEMESSAGE}</p>
                                    </table>
                                </div>

                                <div className="check-heading">{LanguageConstants?.PAYMENT_MATHOD}</div>
                                <div className="d-flex">
                                    <div className="form-check form-check-radio me-4" onClick={()=>setPayMethod('0')} >
                                        <input className="form-check-input" type="radio" name="paymentMethod" id="onlineMethod" />
                                        <label className="form-check-label" htmlFor="onlineMethod">
                                        {LanguageConstants?.ONLINE}
                                        </label>
                                    </div>
                                    {Number(props?.data?.total_amount) >= 20000 ?  
                                    <div className="form-check form-check-radio" onClick={()=>setPayMethod('1')}>
                                        <input className="form-check-input" type="radio" name="paymentMethod" id="offlineMethod" />
                                        <label className="form-check-label" htmlFor="offlineMethod">
                                        {LanguageConstants?.OFFLIE}
                                        </label>
                                    </div>
                                    :null}
                                </div>
                                    <p className='text-error-new'>{error}</p>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={()=>handlePayment()} className="round-btn m-0 w-100" >{LanguageConstants?.PLACE_ORDER}</button>
                        </div>
                    </div>
                </div>
    </div>
    </>
  )
}

export default CheckOutModal